import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext,
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
import { DownloadActions } from '~src/spacesPlatform/services/download/DownloadActions';

import { IContentRevision } from '../serverApi/types/IContentRevision';

export namespace RevisionActions {
  export function downloadContentRevisionAction(): RevisionHistoryActionButton<IContentRevision> {
    return {
      name: 'download',
      translate: 'download_action',
      execute: (context: RevisionHistoryActionContext<IContentRevision>) => {
        DownloadActions.downloadContentRevision(context.selectedItem);
      }
    };
  }
}
